module.exports = __webpack_public_path__ + "img/clound1.8470be03.png";